import {ContextUtil} from "./context";

const v = 0.4;
const d = {
  // endpoint: 'https://cibler.io/',
  // endpoint: 'http://localhost:8080',
  endpoint: 'https://dev.cibler.io',
  customerId: 163,
  version: v
}

const siteContext = () => window.siteContext || {}

const initSiteContext = () => {
  try {
    window.siteContext = JSON.parse(localStorage.getItem("siteContext")) || d;
    if (window.siteContext.version < v) {
      window.siteContext = d;
    }
  } catch (e) {
    window.siteContext = d;
  }
}

const fetchPartner = async () => {
  let partner = getCookie('partner');
  partner = getQueryString("part") ||
    getQueryString('partner') ||
    getQueryString('sponsor') ||
    partner;

  if (!partner) return false;
  const result = await fetch(`/${partner}.json`).then(
    r => {
      if (r.ok && r.status === 200) {
        return r.json();
      }
  })

  if (!result) return false;
  let root = document.documentElement;
  if (!result.sponsor)
    result.sponsor = partner;
  root.style.setProperty('--partnerTxtColor', result.textColor);
  root.style.setProperty('--partnerBtnColor', result.buttonColor);
  ContextUtil.update('partner', result);
  setCookie("partner", partner);

  return partner;
}

const isStringJson = (str) => {
  let result = null;
  try {
    result = JSON.parse(str);
  } catch (e) {
    return false;
  }
  return !!result;
};

const saveContext = () => {
  localStorage.setItem("siteContext", JSON.stringify(siteContext()))
}

const saveOAuthInfo = (inputs) => {
  localStorage.setItem('oauthInfos', JSON.stringify(inputs));
}

const urlEncodeParameters = (details) => {
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return formBody;
}

const loadOAuthInfos = () => {
  const infos = localStorage.getItem('oauthInfos');
  if (!infos || !isStringJson(infos)) return false;

  return JSON.parse(infos);
}

const defaultConfig = {
  "textColor": '#ed6d91',
  "buttonColor": '#ffffff'
}

window.partnerConfig = defaultConfig

const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// function init() {
//     partner = getCookie("partner");
//
//     path = window.location.pathname;
//     const regex = "commerces-([a-z]*)";
//     match = path.match(regex);
//     if (match) {
//         partner = match[1];
//     }
//     if (!window.sellerData)
//         sellerData = {};
//
//     partner = sellerData.partner ||
//         getQueryString("part") ||
//         getQueryString('partner') ||
//         getQueryString('sponsor') ||
//         partner;
//
//     if (partner) {
//         let root = document.documentElement;
//         partnerConfig = partnerConfigMap[partner] || defaultConfig;
//         if (!partnerConfig.sponsor)
//             partnerConfig.sponsor = partner;
//         root.style.setProperty('--partnerTxtColor', partnerConfig.textColor);
//         root.style.setProperty('--partnerBtnColor', partnerConfig.buttonColor);
//         setCookie("partner", partner);
//     }
// }

const getQueryString = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function logout() {
  siteContext().accessKey = "";
  this.saveContext();
}

// function ACtrackEvent(data, event, retry = 0) {
//     if (!window.php_data && retry < 3) {
//         setTimeout(() => ACtrackEvent(data, event, retry + 1), 500);
//         return;
//     }
//     var visit = '{"email":"' + php_data.user_email + '"}'
//     // build the eventString based on the variables you just edited above ☝
//     var eventString = "actid=" + '799887211' +
//         "&key=" + 'bb8c48398cb92757b92f597c4afce2306778e6d0' +
//         "&event=" + event +
//         "&visit=" + encodeURIComponent(visit) +
//         "&eventdata=" + data;
//     // send the event to the ActiveCampaign API with our event values
//     fetch('https://cibler.io/api/activecampaign', {
//         mode: 'no-cors',
//         method: 'POST',
//         headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/x-www-form-urlencoded'
//         },
//         body: eventString
//     });
// }

export {
  initSiteContext,
  fetchPartner,
  saveContext,
  saveOAuthInfo,
  loadOAuthInfos,
  isStringJson,
  siteContext,
  urlEncodeParameters,
}
